import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { LocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/ocpi-cpo-api/models/locations/location.model';
import { CellContext } from '@tanstack/react-table';

export interface EmspBoEmspLocationListCountryCellProps
  extends CellContext<LocationModel, LocationModel['country']> {}

export const EmspBoLocationListCountryCell = (
  props: EmspBoEmspLocationListCountryCellProps,
): React.JSX.Element => {
  const { getValue } = props;

  return <Text truncate>{getValue()}</Text>;
};
